import React from 'react'
import Header from 'src/features/Header'
import Footer from 'src/features/Footer'
import Content from './Content'
import { homeRoutes } from 'src/routes'
import ScrollTopButton from 'src/features/ScrollTopButton'

function Home() {
  return (
    <div className="d-flex flex-column vh-100">
      <Header />
      <div className="flex-grow-1">
        <Content routes={homeRoutes} />
      </div>
      <Footer />
      <ScrollTopButton />
    </div>
  )
}

export default Home
